import React from 'react';
import { Time16 } from '@carbon/icons-react';
import { typicalWaitTimeFormatter } from 'utilities/formatters';
import useOverscrollNavigation from 'customHooks/useOverscrollNavigation';

const ReferralResponseNotReady = ({
  referral,
  onScrollPastEnd,
  onScrollPastStart,
  showPreviousOverscroll,
  showNextOverscroll
}: {
  referral: any;
  onScrollPastEnd?: () => void;
  onScrollPastStart?: () => void;
  showPreviousOverscroll?: boolean;
  showNextOverscroll?: boolean;
}) => {
  const { touchHandlers, OverscrollIndicators } = useOverscrollNavigation({
    onScrollPastEnd,
    onScrollPastStart,
    showPreviousOverscroll,
    showNextOverscroll
  });

  return (
    <div className="mobile-view-response-not-ready" {...touchHandlers}>
      <OverscrollIndicators />

      <div className="mobile-view-not-ready-content">
        <div>
          <Time16 className="mobile-view-time-icon" />
        </div>
        <div className="mobile-view-not-ready-text">
          <div className="mobile-view-not-ready-title">
            The selected response is not ready
          </div>
          <div className="mobile-view-not-ready-description">
            Typical wait time for this asset owner is{' '}
            {typicalWaitTimeFormatter(referral?.waittime)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferralResponseNotReady;
